export const REQUIRED_CHECK_STRING = '01110100 01110010 01110101 01100101'
export const REQUIRED_PASSWORD = 'MWMA-01125813'
export const REFERRAL_CLOSED = 'ONCE_OFF'
